import { onUnmounted as s } from "vue";
import { disposables as e } from "./index338.js";
function t() {
  let o = e();
  return s(() => o.dispose()), o;
}
export {
  t as useDisposables
};
